(() => {

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire2ebf"];
var parcelRegister = parcelRequire.register;
parcelRegister("hycTh", function(module, exports) {
const $bd7fa1fcea984d42$var$init = ()=>{
    const fieldsWrapper = document.querySelectorAll(".f-text:not(.--initialized), .f-textarea:not(.--initialized)");
    fieldsWrapper.forEach((inputField)=>{
        const input = inputField.querySelector(".f-text__input, .f-textarea__input");
        const label = inputField.querySelector(".f-label");
        if (!input) return;
        const hasPlaceholder = !!input.getAttribute("placeholder");
        const addActive = ()=>{
            label?.classList.add("--active");
            inputField.classList.add("--active");
        };
        const removeActive = ()=>{
            label?.classList.remove("--active");
            inputField.classList.remove("--active");
        };
        const isActive = ()=>input.value === "" && !hasPlaceholder && input.type !== "date";
        const handleActive = ()=>{
            isActive() ? removeActive() : addActive();
        };
        input.addEventListener("focusout", handleActive);
        input.addEventListener("input", handleActive);
        input.addEventListener("focus", addActive);
        handleActive() // Init handle
        ;
        input.classList.add("--initialized");
        setTimeout(()=>{
            const isAutofilled = input.matches(":-webkit-autofill") || input.matches(":autofill");
            if (isAutofilled) addActive();
        }, 600);
    });
};
$bd7fa1fcea984d42$var$init();
document.addEventListener("textFieldsReinit", $bd7fa1fcea984d42$var$init);

});

})();
//# sourceMappingURL=text-field.e68eff66.js.map
